require([
    'RunOnEveryPage/components/dummyComponent'
],
function (dummyComp) {
    $(document).ready(function () {
        dummyComp.init();
         	window.onload = function() {
              var d = new Date();
              var n = d.getFullYear();
              //document.getElementById("year").innerHTML = n;
        	};
    });
    
    //$(document).ready(function () {
        
    //    $("#formsModal-6BC278ED-F43A-44C2-A1AD-9756E633A7FF").on("shown.bs.modal", function () {
    //        alert("show modal");
    //        $(".modal-body").html("");
    //    });
    //});
      
    $(document).on("click", '.close-login-frm', function () {        
        //document.getElementById("fxb_00000000-0000-0000-0000-000000000000_6bc278ed-f43a-44c2-a1ad-9756e633a7ff").reset();
        $("#fxb_00000000-0000-0000-0000-000000000000_Fields_dd4bc339-89f1-49c1-baad-6df42fe71b0a__Value").val("");
        $("#fxb_00000000-0000-0000-0000-000000000000_Fields_af9910d6-ea29-4eba-b172-21b8f1d5c578__Value").val("");
        try
        {
            $("#fxb_00000000-0000-0000-0000-000000000000_6bc278ed-f43a-44c2-a1ad-9756e633a7ff").find(".validation-summary-errors").hide();
            //field-validation-error
            $("#fxb_00000000-0000-0000-0000-000000000000_6bc278ed-f43a-44c2-a1ad-9756e633a7ff").find(".field-validation-error").hide();
        }catch(ex)
        {}        
    });

});

define("RunOnEveryPage/main", function(){});

